__turbopack_context__.v({
  "container": "_5dZQsW_container",
  "contentWrapper": "_5dZQsW_contentWrapper",
  "section": "_5dZQsW_section",
});
